// extracted by mini-css-extract-plugin
export default {"dialog":"ProjectDialogs_dialog__pkkfA","btn_row":"ProjectDialogs_btn_row__LvwnR"};